module.exports = __webpack_public_path__ + "media/src/fonts/roboto-mono/roboto-mono-500-medium-9e46ddb18f4d16b8756a1beac39f19a7.woff";